const KEY_ORIGIN = {
  SYSTEM: "system",
  USER: "user",
  USER_DEFINED: "user_defined",
};

const SYSTEM_NSPD_KEYS = {
  GEOMETRY_POINT: "geometry/point",
  GEOMETRY_POLYGON: "geometry/polygon",
};

const getFirstFeature = (json) => {
  if (json?.type === "FeatureCollection" && Array.isArray(json.features)) {
    return json.features[0] || null;
  }

  if (json?.type === "Feature") {
    return json;
  }

  return null;
};

export const getNspdRawValue = (json, field) => {
  const nspdKeyObject = field?.nspd_key;
  const nspdKey = nspdKeyObject?.nspd_key;

  const origin =
    nspdKeyObject?.nspd_key_origin || field?.nspd_key_origin || KEY_ORIGIN.USER;

  if (!nspdKey) return undefined;

  const firstFeature = getFirstFeature(json);

  if (origin === KEY_ORIGIN.SYSTEM) {
    switch (nspdKey) {
      case SYSTEM_NSPD_KEYS.GEOMETRY_POINT:
      case SYSTEM_NSPD_KEYS.GEOMETRY_POLYGON:
        return firstFeature?.geometry;

      default:
        return undefined;
    }
  }

  return (
    // getValueByPath(json, nspdKey) ??
    // getValueByPath(firstFeature, nspdKey) ??
    // getValueByPath(firstFeature?.properties, nspdKey) ??
    getValueByPath(firstFeature?.properties?.options, nspdKey)
  );
};

export const getValueByPath = (source, path) => {
  if (!path) return undefined;

  return path.split(".").reduce((acc, key) => {
    if (acc === null || acc === undefined) return undefined;
    return acc[key];
  }, source);
};
